import React, { Component } from "react";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../../../components/CustomComponent.js";
import {
  report_quotation,
  report_deposit,
  report_loan,
} from "../../../components/Report.js";
export default class Pos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create_customer: false,
      modal_serialno: false,

      serial_list: [],
      product_index: -1,

      product_qrcode: "",
      filter_customer: "",
      filter_repair: "",
      filter_sell: "",
      filter_return: "",

      data_product: [],
      data_customer: [],
      data_warehouse: [],
      data_so: [],
      data_repair: [],
      data_return: [],

      warehouse_id: "",
      ref_number: "",
      user_id: "",
      customer_id: "",
      amount: "",
      discount: "",
      is_vat: false,
      vat: "",
      delivery_cost: "",
      amount_net: "",
      status: "",
      remark: "",
      count_order: 0,
      count_item: 0,
      withdrawal_type: "", // ประเภทการเบิก
      payment_type: "", // รูปแบบการชำระ
      receipt_type: "", // ประเภทใบเสร็จ
      is_delivery: false,

      transaction_list: [],

      // Customer
      full_name: "",
      address: "",
      phone: "",

      amount_deposit: "",
      is_payment: false,
    };
  }

  async componentDidMount() {
    // const dataA = [];
    // const dataB = [];

    // const setA = new Set(dataA);
    // const setB = new Set(dataB);

    // const same = [...setA].filter((x) => setB.has(x));
    // const onlyA = [...setA].filter((x) => !setB.has(x));
    // const onlyB = [...setB].filter((x) => !setA.has(x));

    loading(false);
    await this.Get(1);
  }
  Get = async (page) => {
    let data_customer, data_product, data_warehouse, data_so, data_repair, data_return;
    loading(true);
    let [
      result_customer,
      result_product,
      result_warehouse,
      result_so,
      result_repair,
      result_return
    ] = await Promise.all([
      GET("admin/setting/customers/list", { page: 0, data_search: "" }),
      GET("admin/inventories/list", { page: 0, data_search: "" }),
      GET("admin/setting/warehouses/list", { page: 0, data_search: "" }),
      GET("admin/sales/list", {
        page: 0,
        status_code: "รอสั่งสินค้า",
      }),
      GET("admin/repairs/list", {
        page: 0,
        status_code: "เข้าซ่อม,รอชำระ",
      }),
      GET("admin/stock-activities/list", {
              page: 0,
              data_search: "",
              start_date: "",
              end_date: "",
              activity_type: "เปลี่ยนสินค้า",
              status_code: "เสร็จสิ้น",
              type: "คืนสินค้า",
            })
    ]);

    if (result_customer?.status) {
      data_customer = result_customer.data.map((e) => ({
        value: e.uid,
         label: `${e.full_name}${e.customer_code ? ` ${e.customer_code} | ` : ""}${e.phone ? ` (${e.phone}) ` : ""} ${
            e.address ? ` | ${e.address}` : ""
          }`,
      }));
    }
    if (result_product?.status) {
      data_product = result_product.data
        ?.filter((e) => e.products)
        .map((e) => ({
          value: e.products?.uid,
          label: `${e.products?.product_code} ${e.products?.product_name}`,
          id: e.products?.id,
          warehouse_id: e.products?.warehouse?.uid || "",
          unit_name: e.products?.unit_name,
          unit_price: e.products?.sale_price,
          is_serial_number: e.products?.is_serial_number,
          product_code: e.products?.product_code,
          product_name: e.products?.product_name,
          category_id: e.products?.category?.uid || "",
          balance: e.balance,
          serial_number: e.serial_number,
        }));
    }
    if (result_warehouse?.status) {
      data_warehouse = result_warehouse.data.map((e) => ({
        value: e.uid,
        label: e.name,
      }));
    }
    if (result_so?.status) {
      data_so = result_so.data
        ?.filter((e) => e.payment_type !== "ชำระครบแล้ว")
        .map((e) => ({
          ...e,
          value: e.document_no,
          label: e.document_no,
        }));
    }
    if (result_repair?.status) {
      data_repair = result_repair.data?.map((e) => ({
        ...e,
        value: e.uid,
        label: e.document_no,
        warehouse_id: e.warehouse?.uid,
      }));
    }
    if (result_return?.status) {
      data_return = result_return.data?.map((e) => ({
        ...e,
        value: e.uid,
        label: e.document_no,
        warehouse_id: e.warehouse?.uid,
      }));
    }
    this.setState({
      data_customer,
      data_product,
      data_warehouse,
      data_so,
      data_repair,
      data_return,
      warehouse_id:
        profile?.user_type === "technical"
          ? result_warehouse.data.find(
              (e) => e.id === profile?.warehouse_list[0]
            )?.uid
          : data_warehouse[0]?.value,
    });
    loading(false);
  };
  GetProduct = async () => {
    const result_product = await GET("admin/inventories/list", {
      page: 0,
      data_search: "",
    });
    if (result_product?.status) {
      this.setState({
        data_product: result_product.data
          ?.filter((e) => e.products)
          .map((e) => ({
            value: e.products?.uid,
            label: `${e.products?.product_code} ${e.products?.product_name}`,
            id: e.products?.id,
            warehouse_id: e.products?.warehouse?.uid || "",
            unit_name: e.products?.unit_name,
            is_serial_number: e.products?.is_serial_number,
            product_code: e.products?.product_code,
            product_name: e.products?.product_name,
            category_id: e.products?.category?.uid || "",
            balance: e.balance,
            serial_number: e.serial_number,
            sale_price: e.sale_price,
          })),
      });
    }
  };
  GetReturn = async (uid) => {
    if(uid){
    loading(true);
    const { data_product } = this.state;
    let result = await GET("admin/stock-activities/list", { uid });
    let _new_product = data_product.filter(
                                  (e) => e.warehouse_id === result.data.warehouse?.uid
                                ).find(e=>(e.label).includes("0000004"))
    let _total = 0;

    for(let _new of result.data?.transaction_list_new){
      _total +=  Number(_new.qty) * Number(_new.unit_price);
    }
    for(let _old of result.data?.transaction_list){
      _total -=  Number(_old.qty) * Number(_old.unit_price);
    }
    this.setState({
      transaction_list: [{
                              uid: "",
                              type: "",
                              product_id: _new_product?.value || "",
                              product_name: _new_product?.product_name || "",
                              product_code: _new_product?.product_code || "",
                              product_type: "",
                              serial_number: "",
                              warehouse_id: result.data.warehouse?.uid,
                              warehouse_name: "",
                              category_id: "",
                              category_name: "",
                              qty: 1,
                              unit_name: "",
                              cause: "",
                              discount: "",
                              sale_price: "",
                              cost_price: "",
                              unit_price: _total < 0 ? 0 : _total,
                              amount: _total < 0 ? 0 : _total,
                              remark: "",
                            }],

      warehouse_id: result.data.warehouse?.uid,
      user_id: result.data.user?.uid,
      customer_id: result.data.customer?.uid,
    });
    loading(false);
  }else{
    this.setState({
      transaction_list: [],

      warehouse_id: "",
      user_id: "",
      customer_id: "",
    });
  }
  };
  GetSOByID = async (uid) => {
    if(uid){
    loading(true);
    const { data_product } = this.state;
    let result = await GET("admin/sales/list", { uid });
    this.setState({
      is_payment: result.data.is_vat
        ? toFixed(
            (Number(result.data.amount) - Number(result.data.discount)) * 1.07 +
              Number(result.data.amount_deposit)
          ) === toFixed(Number(result.data.total_pay))
        : toFixed(
            Number(result.data.amount) -
              Number(result.data.discount) +
              Number(result.data.amount_deposit)
          ) === toFixed(Number(result.data.total_pay)),
      uid: result.data.uid,
      transaction_list: result.data.transaction_list.map((e) => ({
        ...e,
        product_id:
          data_product.find(
            (p) =>
              p.id === e.product_id &&
              p.warehouse_id === result.data.warehouse?.uid
          )?.value || "",
        balance:
          data_product.find(
            (p) =>
              p.id === e.product_id &&
              p.warehouse_id === result.data.warehouse?.uid
          )?.balance || 0,
      })),

      warehouse_id: result.data.warehouse?.uid,
      ref_number: result.data.ref_number,
      user_id: result.data.user?.uid,
      customer_id: result.data.customer?.uid,
      amount: result.data.amount,
      amount_deposit: result.data.amount_deposit,
      discount: result.data.discount,
      is_vat: result.data.is_vat,
      vat: result.data.vat,
      delivery_cost: result.data.delivery_cost,
      amount_net: result.data.amount_net,
      status: result.data.status,
      remark: result.data.remark,
      count_order: result.data.count_order,
      count_item: result.data.count_item,
      withdrawal_type: result.data.withdrawal_type,
      payment_type: result.data.payment_type,
      receipt_type: result.data.receipt_type,
      is_delivery: result.data.is_delivery,
    });
    loading(false);
  }else{
    this.setState({
      is_payment: false,
      uid: "",
      transaction_list: [],

      warehouse_id: "",
      ref_number: "",
      user_id: "",
      customer_id: "",
      amount: "",
      discount: "",
      is_vat: false,
      vat: "",
      delivery_cost: "",
      amount_net: "",
      status: "",
      remark: "",
      count_order: "",
      count_item: "",
      withdrawal_type: "",
      payment_type: "",
      receipt_type: "",
      is_delivery: false,
    });
  }
  };
  CreateUpdate = async (_status) => {
    const {
      data_return,
      filter_repair,
      uid,
      warehouse_id,
      ref_number,
      user_id,
      customer_id,
      discount,
      amount_deposit,
      is_vat,
      vat,
      delivery_cost,
      status,
      remark,
      count_order,
      count_item,
      withdrawal_type,
      payment_type,
      receipt_type,
      is_delivery,
      transaction_list,
      is_payment,
      filter_return
    } = this.state;
    if (!customer_id.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกลูกค้า");
      return;
    }
    if (!withdrawal_type) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกประเภทการซื้อ");
      return;
    }
    if (!payment_type) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกประเภทการชำระ");
      return;
    }
    if (!receipt_type) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกประเภทใบเสร็จ");
      return;
    }
    let amount = 0;

    if (transaction_list.length === 0) {
      alert(
        "",
        "warning",
        "แจ้งเตือน",
        "กรุณาเพิ่มรายการสินค้าอย่างน้่อย 1 รายการ"
      );
      return;
    }

    for (let item of transaction_list) {
      // if (!item.unit_price || Number(item.unit_price) <= 0) {
      //   alert("", "warning", "แจ้งเตือน", "กรุณากรอกราคาต่อหน่วย");
      //   return;
      // }
      item.unit_price = item.unit_price || 0;
      amount +=
        Number(item.qty) * (Number(item.unit_price) || 0) -
        (Number(item.discount) || 0);
    }
    let action = true;
    if (uid && _status === "รอชำระ" && withdrawal_type === "รอสั่งสินค้า") {
      action = false;
      if (
        await alert(
          "",
          "info",
          "ยืนยันรายการ",
          `ยืนยันการเปลี่ยนแปลงสถานะจาก "รอสั่งสินค้า" ไปเป็น "รอชำระ" หรือไม่`,
          "ยืนยัน",
          "ยกเลิก"
        )
      ) {
        action = true;
      }
    }
    if (action === false) {
      return;
    }
    loading(true);
    let body = {
      warehouse_id: warehouse_id,
      repair_id: filter_repair,
      ref_number: data_return?.filter(e=>e.warehouse_id === warehouse_id).find(e=>e.value === filter_return)?.label || "",
      user_id: user_id,
      customer_id: customer_id,
      amount: Number(amount),
      discount: Number(discount),
      amount_deposit: Number(amount_deposit),
      is_vat: receipt_type === "ต้องการ Vat",
      vat: receipt_type === "ต้องการ Vat" ? Number(amount * 0.07) : 0,
      delivery_cost: Number(delivery_cost),
      amount_net: Number(amount),
      status: _status,
      remark: remark,
      count_order: transaction_list.length,
      count_item: total(transaction_list, "qty"),
      withdrawal_type:
        _status === "รอชำระ" && withdrawal_type === "รอสั่งสินค้า"
          ? "ขายหน้าร้าน"
          : withdrawal_type,
      payment_type: is_payment
        ? "ชำระครบแล้ว"
        : payment_type || "ชำระเงินทันที",
      receipt_type: receipt_type || "ไม่ต้องการ Vat",
      is_delivery: is_delivery,

      transaction_list: transaction_list,
    };

    let result = !uid
      ? await POST("admin/sales/create", body)
      : await PUT("admin/sales/update/" + uid, body);
    if (result?.status) {
       let result2 = await GET("admin/sales/list", { uid: uid || result.data });
      Swal.fire({
        title: "พิมพ์เอกสาร",
        text: "",
        html: `
            <div class="w-100">
                                            <button id="btn-report-quotation" class="btn btn-outline-dark w-100 mb-3 text-start">
                                              <span class="icon me-2">&#xf15b;</span>
                                              ใบเสนอราคา
                                            </button>
                                            <button id="btn-report-deposit" class="btn btn-outline-dark w-100 mb-3 text-start">
                                              <span class="icon me-2">&#xf15b;</span>
                                              ใบมัดจำสินค้า
                                            </button>
                                            <button id="btn-report-loan" class="btn btn-outline-dark w-100 mb-3 text-start">
                                              <span class="icon me-2">&#xf15b;</span>
                                              ใบยืมสินค้า
                                            </button>
                                          </div>
          `,
        showConfirmButton: false,
        showCancelButton: false,
        showCloseButton: true,
        didOpen: () => {
          document
            .getElementById("btn-report-quotation")
            .addEventListener("click", () => {
              report_quotation(uid || result.data);
            });
          document
            .getElementById("btn-report-deposit")
            .addEventListener("click", () => {
              report_deposit(uid || result.data);
            });
          document
            .getElementById("btn-report-loan")
            .addEventListener("click", () => {
              report_loan(uid || result.data);
            });
        },
      }).then((res) => {
        if (res.dismiss) {
          window.location.reload();
        }
      });
    } else {
      alert(
        "",
        "warning",
        "แจ้งเตือน",
        result?.message || "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง"
      );
    }
    loading(false);
  };

  CreateCustomer = async () => {
    const { full_name, address, phone } = this.state;
    if (!full_name.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกชื่อ-สกุล");
      return;
    } else if (!phone.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกเบอร์โทร");
      return;
    }

    loading(true);
    let body = {
      prefix_name: "",
      full_name,
      address,
      phone,
      tax_number: "",
      payment_conditions: "",
      cars: [],
    };

    let result = await POST("admin/setting/customers/create", body);
    if (result?.status) {
      let data_customer;
      let [result_customer] = await Promise.all([
        GET("admin/setting/customers/list", { page: 0, data_search: "" }),
      ]);

      if (result_customer?.status) {
        data_customer = result_customer.data.map((e) => ({
          value: e.uid,
          label: `${e.full_name}${e.customer_code ? ` ${e.customer_code} | ` : ""}${e.phone ? ` (${e.phone}) ` : ""} ${
            e.address ? ` | ${e.address}` : ""
          }`,
        }));
      }
      this.setState({ data_customer, modal_create_customer: false });
    } else {
      alert(
        "",
        "warning",
        "แจ้งเตือน",
        result?.message || "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง"
      );
    }
    loading(false);
  };
  render() {
    const {
      modal_create_customer,

      product_qrcode,
      filter_customer,
      filter_repair,
      filter_sell,
      filter_return,

      data_product,
      data_customer,
      data_warehouse,
      data_so,
      data_repair,
      data_return,

      uid,
      warehouse_id,
      ref_number,
      user_id,
      customer_id,
      amount,
      discount,
      is_vat,
      vat,
      delivery_cost,
      amount_net,
      status,
      remark,
      count_order,
      count_item,
      withdrawal_type,
      payment_type,
      receipt_type,
      is_delivery,
      transaction_list,

      amount_deposit,

      full_name,
      address,
      phone,

      modal_serialno,
      serial_list,
      product_index,
      is_payment,
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="body p-3">
          <div className="row mb-5">
            <div className="col-12 col-xxl-10">
              <div className="rounded-4 bg-white d-flex justify-content-between p-3 mb-3">
                <div className="d-flex">
                  <div className="px-3">
                    <span>รายการ</span>
                    <h2 className="fw-bold">{transaction_list?.length}</h2>
                  </div>
                  <div className="px-3">
                    <span>ชิ้น</span>
                    <h2 className="fw-bold">
                      {total(transaction_list, "qty")}
                    </h2>
                  </div>
                </div>
                <div className="px-3 text-end">
                  <span>รวมสุทธิ</span>
                  <h2 className="fw-bold">
                    {toFixed(
                      (() => {
                        let total = 0;
                        for (let item of transaction_list) {
                          total +=
                            Number(item.qty) * (Number(item.unit_price) || 0) -
                            (Number(item.discount) || 0);
                        }
                        return total;
                      })()
                    )}
                  </h2>
                </div>
              </div>
              <div className="rounded-4 bg-white p-3 mb-3">
                <div className="d-flex flex-wrap justify-content-between">
                  <h4 className="fw-bold mb-3 me-3">การขาย</h4>
                  <div className="d-flex flex-wrap">
                    <Select
                      options={data_return?.filter(e=>e.warehouse_id === warehouse_id)}
                      className="form-control wpx-200 me-2 mb-2"
                      placeholder="เลขที่คืนสินค้า..."
                      onChange={(e, i) => {
                        this.setState({
                          filter_return: e,
                          filter_repair: "",
                          filter_sell: "",
                        },() => {this.GetReturn(e)});
                      }}
                      value={filter_return}
                      disabled={filter_sell || filter_repair}
                    />
                    <Select
                      options={data_repair}
                      className="form-control wpx-200 me-2 mb-2"
                      placeholder="เลขแจ้งซ่อม..."
                      onChange={(e, i) => {
                        window.location.href =
                          "/stock/withdrawal-goods?repair_id=" +
                          e +
                          "&warehouse_id=" +
                          i.warehouse_id;
                      }}
                      value={filter_repair}
                      disabled={filter_sell || filter_return}
                    />
                    <Select
                      options={data_so}
                      className="form-control wpx-200 me-2 mb-2"
                      placeholder="ใบขาย..."
                      onChange={(e, i) => {
                        this.setState({
                          filter_sell: e,
                          filter_return: "",
                          filter_repair: "",
                          is_payment: false,
                        });
                        if (e) {
                          this.GetSOByID(i.uid);
                        }
                      }}
                      value={filter_sell}
                      disabled={filter_repair || filter_return}
                    />
                    <div className="d-flex">
                      <button
                        className="btn btn-dark px-3 me-2 mb-2"
                        onClick={() => {
                          this.Get(1);
                        }}
                      >
                        ค้นหา
                      </button>
                      <button
                        className="btn btn-outline-dark px-3 me-2 mb-2"
                        onClick={() => {
                          window.location.reload();
                        }}
                      >
                        ล้างค่า
                      </button>
                    </div>
                  </div>
                </div>
                <div className="d-flex flex-wrap">
                  <Select
                    options={data_customer}
                    className="form-control wpx-250 me-2 mb-2"
                    placeholder="ข้อมูลลูกค้า..."
                    onChange={(e) => {
                      this.setState({ customer_id: e });
                    }}
                    value={customer_id}
                  />{" "}
                  {["super_user", "admin"].includes(profile?.user_type) && (
                    <Select
                      className="form-control  wpx-250 me-2 mb-2"
                      placeholder="เลือกคลังสินค้า..."
                      options={data_warehouse}
                      onChange={(e) => {
                        this.setState({ warehouse_id: e,filter_return: "" });
                      }}
                      value={warehouse_id}
                      disabled={transaction_list.length !== 0}
                    />
                  )}
                  <input
                    type="text"
                    className="form-control wpx-250 me-2 mb-2"
                    placeholder="สแกนบาร์โค้ดเพื่อเพิ่มสินค้า..."
                    onChange={(e) => {
                      this.setState({
                        product_qrcode: e.target.value,
                      });
                    }}
                    onKeyUp={(e) => {
                      if (e.key === "Enter") {
                        const product_code = product_qrcode.split("|")[0] || "";
                        const product_serial =
                          product_qrcode.split("|")[1] || "";
                        let _transaction_list = transaction_list;
                        let index = _transaction_list.findIndex(
                          (t) => t.product_code === product_code
                        );
                        if (index !== -1) {
                          _transaction_list[index].qty += 1;
                          const is_serial_number = data_product.find(
                            (e) =>
                              e.warehouse_id === warehouse_id &&
                              e.product_code === product_code
                          )?.is_serial_number;
                          if (is_serial_number) {
                            _transaction_list[index].serial_number =
                              _transaction_list[index].serial_number
                                ? _transaction_list[index].serial_number +
                                  "," +
                                  product_serial
                                : product_serial;
                          }
                          this.GetProduct();
                        } else {
                          const product = data_product.filter(
                            (e) => e.warehouse_id === warehouse_id
                          );
                          const select_product = product.find(
                            (p) => p.product_code === product_code
                          );
                          if (select_product) {
                            _transaction_list = [
                              ...transaction_list,
                              {
                                uid: "",
                                type: "",
                                product_id: select_product.value,
                                product_name: select_product.product_name,
                                product_code: select_product.product_code,
                                product_type: select_product.product_type,
                                serial_number: select_product.is_serial_number
                                  ? product_serial
                                  : "",
                                warehouse_id: warehouse_id,
                                balance: select_product.balance,
                                warehouse_name: "",
                                category_id: "",
                                category_name: "",
                                qty: 1,
                                unit_name: "",
                                cause: "",
                                discount: "",
                                sale_price: "",
                                cost_price: "",
                                unit_price: "",
                                amount: "",
                                remark: "",
                              },
                            ];
                          } else {
                            alert(
                              "",
                              "info",
                              "แจ้งเตือน",
                              "ไม่มีรหัสสินค้านี้ในระบบ"
                            );
                            return;
                          }
                        }
                        this.setState({
                          product_qrcode: "",
                          product_serial: "",
                          transaction_list: _transaction_list,
                        });
                      }
                    }}
                    value={product_qrcode}
                  />
                  <button
                    className="btn btn-dark px-3 me-2 mb-2"
                    onClick={() => {
                      this.setState(
                        {
                          transaction_list: [
                            ...this.state.transaction_list,
                            {
                              uid: "",
                              type: "",
                              product_id: "",
                              product_name: "",
                              product_code: "",
                              product_type: "",
                              serial_number: "",
                              warehouse_id: warehouse_id,
                              warehouse_name: "",
                              category_id: "",
                              category_name: "",
                              qty: 1,
                              unit_name: "",
                              cause: "",
                              discount: "",
                              sale_price: "",
                              cost_price: "",
                              unit_price: "",
                              amount: "",
                              remark: "",
                            },
                          ],
                        },
                        () => {
                          try {
                            const index =
                              this.state.transaction_list.length - 1;
                            document.getElementById("price-" + index)?.focus();
                          } catch (e) {
                            console.error(
                              "Error focusing on product input:",
                              e
                            );
                          }
                        }
                      );
                    }}
                  >
                    เพิ่มรายการสินค้า
                  </button>
                  {((profile?.user_type !== "technical") || (payment_type === "ชำระเงินทันที" && profile?.user_type === "technical")) && (
                  <button
                    className="btn btn-dark px-3 me-2 mb-2"
                    onClick={() => {
                      this.setState({
                        modal_create_customer: true,
                        full_name: "",
                        address: "",
                        phone: "",
                      });
                    }}
                  >
                    เพิ่มลูกค้า
                  </button>
                  )}
                </div>
                <div>
                  <table className="table rounded-3 table-hover">
                    <thead>
                      <tr>
                        <td className="text-nowrap">ลำดับ</td>
                        <td className="text-nowrap">รหัส/ชื่อสินค้า</td>
                        <td className="text-nowrap">Serial No.</td>
                        <td className="text-nowrap text-center">คงเหลือ</td>
                        <td className="text-nowrap text-center">จำนวน</td>
                        <td className="text-nowrap">ราคาต่อหน่วย</td>
                        <td className="text-nowrap">ราคารวม</td>
                        <td className="text-nowrap">ส่วนลด</td>
                        <td className="text-nowrap">จำนวนเงินสุทธิ</td>
                        <td></td>
                      </tr>
                    </thead>
                    <tbody>
                      {transaction_list?.map((item, index) => (
                        <tr>
                          <td className="text-nowrap text-center">
                            {index + 1}
                          </td>
                          <td className="text-nowrap">
                            <div className="d-flex align-items-center">
                              <Select
                                className="form-control"
                                placeholder="ค้นหาสินค้า..."
                                options={data_product.filter(
                                  (e) => e.warehouse_id === warehouse_id
                                )}
                                onChange={(e, i) => {
                                  transaction_list[index].product_id = e;
                                  transaction_list[index].product_code =
                                    i.product_code;
                                  transaction_list[index].product_name =
                                    i.product_name;
                                  transaction_list[index].unit_name =
                                    i.unit_name;
                                  transaction_list[index].unit_price =
                                    i.unit_price || "";
                                  transaction_list[index].serial_number = "";
                                  transaction_list[index].balance = i.balance;
                                  transaction_list[index].remark = "";
                                  this.setState({ transaction_list });
                                }}
                                value={item.product_id}
                              />
                              {item.product_code?.includes("-00000") && (
                                <div className="ms-2">
                                  <BtnIcon
                                    type="approve"
                                    onClick={() => {
                                      Swal.fire({
                                        title: "หมายเหตุ",
                                        text: `กรอกหมายเหตุของสินค้า "${item.product_name}"`,
                                        icon: "info",
                                        input: "textarea",
                                        inputPlaceholder: "หมายเหตุ...",
                                        inputValue: item.remark || "",
                                        showCancelButton: true,
                                        confirmButtonText: "บันทึก",
                                        cancelButtonText: "ยกเลิก",
                                      }).then(async (re) => {
                                        if (re.isConfirmed) {
                                          const remark = re.value;
                                          transaction_list[index].remark =
                                            remark;
                                          this.setState({ transaction_list });
                                        }
                                      });
                                    }}
                                  />
                                </div>
                              )}
                            </div>
                            {item.remark && (
                              <small className="px-2">
                                หมายเหตุ : {item.remark}
                              </small>
                            )}
                          </td>
                          <td className="text-nowrap">
                            {data_product.find(
                              (e) => e.value === item.product_id
                            )?.is_serial_number && (
                              <div className="d-flex align-items-center">
                                <input
                                  type="text"
                                  className="form-control mx-1"
                                  onChange={(e) => {
                                    transaction_list[index].serial_number =
                                      e.target.value;
                                    this.setState({ transaction_list });
                                  }}
                                  value={item.serial_number}
                                />
                                <BtnIcon
                                  type="update"
                                  title="เลือก Serial No."
                                  onClick={() => {
                                    this.setState({
                                      modal_serialno: true,
                                      product_index: index,
                                      serial_list: data_product
                                        .find(
                                          (e) =>
                                            e.product_code ===
                                              item.product_code &&
                                            e.warehouse_id === item.warehouse_id
                                        )
                                        ?.serial_number.map((e) => ({
                                          serial_number: e,
                                          selected:
                                            item.serial_number.includes(e),
                                        })),
                                    });
                                  }}
                                />
                              </div>
                            )}
                          </td>
                          <td className="text-center">{item.balance || 0}</td>
                          <td className="text-nowrap">
                            <div className="d-flex justify-content-center">
                              <button
                                className="btn btn-primary wpx-30"
                                onClick={async () => {
                                  if (item.qty <= 1) {
                                    if (
                                      await alert(
                                        "",
                                        "info",
                                        "ยืนยัน",
                                        "ยืนยันการลบข้อมูลนี้หรือไม่",
                                        "ลบข้อมูล",
                                        "ยกเลิก"
                                      )
                                    ) {
                                      this.setState({
                                        transaction_list:
                                          transaction_list.filter(
                                            (_, i) => i !== index
                                          ),
                                      });
                                    }
                                  } else {
                                    transaction_list[index].qty = Math.max(
                                      0,
                                      item.qty - 1
                                    );
                                    this.setState({ transaction_list });
                                  }
                                }}
                              >
                                -
                              </button>
                              <input
                                type="text"
                                className="form-control wpx-50 mx-1 text-center px-1"
                                onChange={(e) => {
                                  if (!float(e.target.value)) return;
                                  transaction_list[index].qty = Number(
                                    e.target.value
                                  );
                                  this.setState({ transaction_list });
                                }}
                                value={item.qty}
                              />
                              <button
                                className="btn btn-primary wpx-30"
                                onClick={() => {
                                  transaction_list[index].qty = Math.max(
                                    0,
                                    item.qty + 1
                                  );
                                  this.setState({ transaction_list });
                                }}
                              >
                                +
                              </button>
                            </div>
                          </td>
                          <td className="text-nowrap">
                            <input
                              type="text"
                              className="form-control wpx-90 mx-1 text-end px-1"
                              onChange={(e) => {
                                if (!float(e.target.value)) return;
                                transaction_list[index].unit_price =
                                  e.target.value;
                                this.setState({ transaction_list });
                              }}
                              onKeyUp={(e) => {
                                if (e.key === "Enter") {
                                  if (index === transaction_list.length - 1) {
                                    this.setState(
                                      {
                                        transaction_list: [
                                          ...transaction_list,
                                          {
                                            uid: "",
                                            type: "",
                                            product_id: "",
                                            product_name: "",
                                            product_code: "",
                                            product_type: "",
                                            serial_number: "",
                                            warehouse_id: "",
                                            warehouse_name: "",
                                            category_id: "",
                                            category_name: "",
                                            qty: 1,
                                            unit_name: "",
                                            cause: "",
                                            discount: "",
                                            sale_price: "",
                                            cost_price: "",
                                            unit_price: "",
                                            amount: "",
                                            remark: "",
                                          },
                                        ],
                                      },

                                      () => {
                                        try {
                                          const index =
                                            this.state.transaction_list.length -
                                            1;
                                          document
                                            .getElementById("price-" + index)
                                            ?.focus();
                                        } catch (e) {
                                          console.error(
                                            "Error focusing on product input:",
                                            e
                                          );
                                        }
                                      }
                                    );
                                  } else {
                                    try {
                                      document
                                        .getElementById("price-" + (index + 1))
                                        .focus();
                                    } catch (e) {
                                      console.error(
                                        "Error focusing on product input:",
                                        e
                                      );
                                    }
                                  }
                                }
                              }}
                              value={item.unit_price}
                              id={`price-${index}`}
                            />
                          </td>
                          <td className="text-nowrap text-end text-primary">
                            {toFixed(
                              Number(item.unit_price) * Number(item.qty)
                            )}
                          </td>
                          <td className="text-nowrap">
                            <input
                              type="text"
                              className="form-control wpx-70 mx-1 text-end px-1"
                              onChange={(e) => {
                                if (!float(e.target.value)) return;
                                transaction_list[index].discount =
                                  e.target.value;
                                this.setState({ transaction_list });
                              }}
                              value={item.discount}
                            />
                          </td>
                          <td className="text-nowrap text-end text-primary">
                            {toFixed(
                              Number(item.unit_price) * Number(item.qty) -
                                Number(item.discount)
                            )}
                          </td>
                          <td className="text-center">
                            <div className="d-flex">
                              <BtnIcon
                                className="receive-goods.delete"
                                type="delete"
                                onClick={async () => {
                                  if (
                                    await alert(
                                      "",
                                      "info",
                                      "ยืนยัน",
                                      "ยืนยันการลบข้อมูลนี้หรือไม่",
                                      "ลบข้อมูล",
                                      "ยกเลิก"
                                    )
                                  ) {
                                    this.setState({
                                      transaction_list: transaction_list.filter(
                                        (_, i) => i !== index
                                      ),
                                    });
                                  }
                                }}
                              />
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="col-12 col-xxl-2">
              <div className="rounded-4 bg-white p-3">
                <div className="row">
                  <div className="col-12 col-sm-6 col-xxl-12">
                    <div className="fw-bold mb-2">ประเภทการซื้อ</div>
                    <div className="d-flex d-lg-block flex-wrap">
                      <button
                        className={`btn ${
                          withdrawal_type === "ขายหน้าร้าน"
                            ? "btn-primary"
                            : "btn-light"
                        } mb-2 me-2 text-nowrap`}
                        onClick={() =>
                          this.setState({ withdrawal_type: "ขายหน้าร้าน" })
                        }
                        disabled={filter_sell || filter_repair}
                      >
                        ขายหน้าร้าน
                      </button>
                      <button
                        className={`btn ${
                          withdrawal_type === "เบิกแจ้งซ่อม"
                            ? "btn-primary"
                            : "btn-light"
                        } mb-2 me-2 text-nowrap`}
                        onClick={() =>
                          this.setState({ withdrawal_type: "เบิกแจ้งซ่อม" })
                        }
                        disabled={filter_sell || filter_repair}
                      >
                        เบิกแจ้งซ่อม
                      </button>
                      <button
                        className={`btn ${
                          withdrawal_type === "รอสั่งสินค้า"
                            ? "btn-primary"
                            : "btn-light"
                        } mb-2 me-2 text-nowrap`}
                        onClick={() =>
                          this.setState({ withdrawal_type: "รอสั่งสินค้า" })
                        }
                        disabled={filter_sell || filter_repair}
                      >
                        รอสั่งสินค้า
                      </button>
                    </div>
                    <hr />
                  </div>

                  <div className="col-12 col-sm-6 col-xxl-12">
                    <div className="fw-bold mb-2">รูปแบบการชำระ</div>
                    <div className="d-flex d-lg-block flex-wrap">
                      <button
                        className={`btn ${
                          payment_type === "ชำระเงินทันที"
                            ? "btn-primary"
                            : "btn-light"
                        } mb-2 me-2 text-nowrap`}
                        onClick={() =>
                          this.setState({
                            payment_type: "ชำระเงินทันที",
                            amount_deposit:  filter_sell ? amount_deposit : "",
                          })
                        }
                        disabled={is_payment}
                      >
                        ชำระเงินทันที
                      </button>
                      <button
                        className={`btn ${
                          payment_type === "ชำระมัดจำ"
                            ? "btn-primary"
                            : "btn-light"
                        } mb-2 me-2 text-nowrap`}
                        onClick={() =>
                          this.setState({
                            payment_type: "ชำระมัดจำ",
                            amount_deposit: filter_sell ? amount_deposit : "",
                          })
                        }
                        disabled={is_payment}
                      >
                        ชำระมัดจำ
                      </button>
                      <button
                        className={`btn ${
                          payment_type === "ชำระเงินเชื่อ"
                            ? "btn-primary"
                            : "btn-light"
                        } mb-2 me-2 text-nowrap`}
                        onClick={() =>
                          this.setState({
                            payment_type: "ชำระเงินเชื่อ",
                            amount_deposit: filter_sell ? amount_deposit : "",
                          })
                        }
                        disabled={is_payment}
                      >
                        ชำระเงินเชื่อ
                      </button>
                    </div>
                    <hr />
                  </div>

                  <div className="col-12 col-sm-6 col-xxl-12">
                    <div className="fw-bold mb-2">ประเภทใบเสร็จ</div>
                    <div className="d-flex d-lg-block flex-wrap">
                      <button
                        className={`btn ${
                          receipt_type === "ไม่ต้องการ Vat"
                            ? "btn-primary"
                            : "btn-light"
                        } mb-2 me-2 text-nowrap`}
                        onClick={() =>
                          this.setState({
                            receipt_type: "ไม่ต้องการ Vat",
                            is_vat: false,
                          })
                        }
                      >
                        ไม่ต้องการ Vat
                      </button>
                      <button
                        className={`btn ${
                          receipt_type === "ต้องการ Vat"
                            ? "btn-primary"
                            : "btn-light"
                        } mb-2 me-2 text-nowrap`}
                        onClick={() =>
                          this.setState({
                            receipt_type: "ต้องการ Vat",
                            is_vat: true,
                          })
                        }
                      >
                        ต้องการ Vat
                      </button>
                    </div>
                    <hr />
                  </div>

                  <div className="col-12 col-sm-6 col-xxl-12">
                    <div className="fw-bold mb-2">ส่งปลายทาง</div>
                    <Switch
                      onChange={(e) => {
                        this.setState({ is_delivery: e });
                      }}
                      checked={is_delivery}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="bg-white p-3 d-flex justify-content-end position-fixed w-100"
          style={{ bottom: 0, left: 0 }}
        >
          {is_payment && (
            <div className="px-3 py-0 border-2 border-danger text-20 fw-bold rounded-4 me-2 text-danger">
              ชำระครบแล้ว
            </div>
          )}
          <input
            type="text"
            className="form-control wpx-200 me-2"
            placeholder="หมายเหตุ"
            onChange={(e) => {
              this.setState({ remark: e.target.value });
            }}
            value={remark}
          />
          {payment_type === "ชำระมัดจำ" && (
            <input
              type="text"
              className="form-control wpx-180 me-2"
              placeholder="ยอดมัดจำ"
              onChange={(e) => {
                if (!float(e.target.value)) return;
                this.setState({ amount_deposit: e.target.value });
              }}
              value={amount_deposit}
            />
          )}
          <button
            className="btn btn-dark px-3 me-2"
            onClick={async () => {
              let _status = "รอชำระ";
              if (withdrawal_type === "รอสั่งสินค้า" && !uid) {
                _status = "รอสั่งสินค้า";
              }
              this.CreateUpdate(_status);
            }}
          >
            พิมพ์ออร์เดอร์
          </button>
        </div>

        {/* CREATE UPDATE */}
        <Modal
          show={modal_create_customer}
          onHide={() => this.setState({ modal_create_customer: false })}
        >
          <Modal.Header className="border-0" closeButton>
            <h5 className="fw-bold mb-0">เพิ่มลูกค้า</h5>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">ชื่อ-นามสกุล{required}</div>
              <input
                type="text"
                className="form-control"
                placeholder="ชื่อ-นามสกุล..."
                onChange={(e) => {
                  this.setState({ full_name: e.target.value });
                }}
                value={full_name}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">เบอร์โทร{required}</div>
              <input
                type="text"
                className="form-control"
                placeholder="เบอร์โทร..."
                onChange={(e) => {
                  if (!float(e.target.value)) return;
                  this.setState({ phone: e.target.value });
                }}
                value={phone}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">ที่อยู่</div>
              <textarea
                className="form-control"
                placeholder="ที่อยู่..."
                rows={5}
                onChange={(e) => {
                  this.setState({ address: e.target.value });
                }}
                value={address}
              />
            </div>
          </Modal.Body>
          <Modal.Footer className="pt-0 border-0 d-flex justify-content-end">
            <div className="d-flex">
              <button
                className="btn btn-dark px-5 me-1"
                onClick={() => {
                  this.CreateCustomer();
                }}
              >
                บันทึก
              </button>
              <button
                className="btn btn-outline-dark px-5 ms-1"
                onClick={() => {
                  this.setState({ modal_create_customer: false });
                }}
              >
                ยกเลิก
              </button>
            </div>
          </Modal.Footer>
        </Modal>
        <Modal
          show={modal_serialno}
          onHide={() => this.setState({ modal_serialno: false })}
        >
          <Modal.Header className="border-0" closeButton>
            <h5 className="fw-bold mb-0">เลือก Serial No.</h5>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <div className="table-responsive mb-3">
              <table className="table table-hover table-striped-columns">
                <thead>
                  <tr>
                    <td className="text-nowrap wpx-50 text-center">
                      <input
                        type="checkbox"
                        onChange={(e) => {
                          const checked = e.target.checked;
                          this.setState({
                            serial_list: serial_list.map((item) => ({
                              ...item,
                              selected: checked,
                            })),
                          });
                        }}
                        checked={serial_list.every((item) => item.selected)}
                      />
                    </td>
                    <td className="text-nowrap">Serial No.</td>
                  </tr>
                </thead>
                <tbody>
                  {serial_list?.map((item, index) => (
                    <tr style={{ cursor: "pointer" }}>
                      <td className="text-center">
                        <input
                          type="checkbox"
                          onChange={(e) => {
                            let _data = [...serial_list];
                            _data[index].selected = e.target.checked;
                            this.setState({ serial_list: _data });
                          }}
                          checked={item.selected}
                        />
                      </td>
                      <td>{item.serial_number}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Modal.Body>
          <Modal.Footer className="pt-0 border-0 d-flex justify-content-end">
            <div className="d-flex">
              <button
                className="btn btn-dark px-5 me-1"
                onClick={() => {
                  let _data = transaction_list;
                  _data[product_index].serial_number = serial_list
                    .filter((e) => e.selected)
                    .map((e) => e.serial_number)
                    .toString();
                  this.setState({
                    transaction_list: _data,
                    modal_serialno: false,
                    product_index: -1,
                  });
                }}
              >
                บันทึก
              </button>
              <button
                className="btn btn-outline-dark px-5 ms-1"
                onClick={() => {
                  this.setState({ modal_serialno: false });
                }}
              >
                ยกเลิก
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
